import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import ShowOwnerResidentialInfo from "../../../Controls/ShowOwnerResidentialInfo"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let FileExt = '';
export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [getServiceIframeResult, setServiceIframeResult] = useState('');
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetArchiveCategoryList", inputValue, GetArchiveCategoryListSuccess);
	}, []);

	const GetArchiveCategoryListSuccess = (ServiceResult) => {
		let ServiceResults = ServiceResult.ArchiveCategoryListResult.concat(ServiceResult.ArchiveNotCategoryListResult).concat(ServiceResult.ArchiveFileListResult);
		setServiceResult(ServiceResults);
	}

	const ViewAction = (row) => {
		FileExt = row.FileExtension;

		let ArchiveNotCategoryRowList = [];

		row.ArchiveCategoryRowListResult?.forEach((item) => {
			ArchiveNotCategoryRowList.push(Number(item.Row));
		});

		row.ArchiveNotCategoryRowListResult?.forEach((item) => {
			ArchiveNotCategoryRowList.push(Number(item.Row));
		});

		if (row.FileExtension !== 'jpg') {
			ArchiveNotCategoryRowList = [Number(row.Row)];
		}

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			parentSequence: row.ParentSequence,
			row: ArchiveNotCategoryRowList
		};

		EmployeeSessionCheckFetch(
			"Employee/Urbanization/Request/GetArchiveCategoryFetch",
			inputValue,
			GetArchiveCategoryFetchSuccess,
			GetArchiveCategoryFetchFail
		);
	}

	const GetArchiveCategoryFetchSuccess = (ServiceResult) => {
		if (FileExt != 'jpg') {
			setShowModal(false);
			setServiceIframeResult(false);
			var a = document.createElement("a");
			a.href = Base64Type(FileExt) + ServiceResult.ArchiveCategoryListResult[0].Base64Content;
			a.download = Math.floor(Math.random() * 10000) + "." + FileExt;
			a.click();
			a.remove();
		} else {
			setShowModal(true);

			setServiceIframeResult(ServiceResult)
		}
	}
	const hideModal = () => {
		setServiceIframeResult("")
		setShowModal(false);
	}

	const GetArchiveCategoryFetchFail = (ServiceResult) => {
		hideModal()
	}

	let customRenderCell = {
		CreatedOn: (row) => (
			<div dir="ltr">{row.CreatedOn}</div>
		)
	};

	const GetDownload = (getServiceIframeResult, i) => {
		var a = document.createElement("a");
		a.href = Base64Type('jpeg') + getServiceIframeResult.ArchiveCategoryListResult[i].Base64Content;
		a.download = Math.floor(Math.random() * 10000) + ".jpg"
		a.click();
		a.remove();
	}

	return (
		<div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')} />

			<GridControl
				data={getServiceResult}
				customHeaders={{ "Title": "عنوان", "AttachDataSize": "حجم تصاویر", "FileExtension": "نوع فایل", "ViewAction": "نمایش" }}
				ViewAction={ViewAction}
				customRenderCell={customRenderCell}
			/>

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{
						getServiceIframeResult && getServiceIframeResult.ArchiveCategoryListResult.map((item, i) => (
							<div>
								<img width="100%" src={Base64Type('jpeg') + getServiceIframeResult.ArchiveCategoryListResult[i].Base64Content} />
								<ButtonControl
									variant="primary my-3"
									title="دانلود"
									onClick={() => GetDownload(getServiceIframeResult, i)}
									icon="fa fa-download"
								/>
								<hr style={{ border: "1px dashed #000" }} />
							</div>
						))
					}
				</Modal.Body>
				<Modal.Footer>
					{/*<Button variant="primary" onClick={()=>GetDownload(false)}>
					دانلود
				</Button>*/}
					<Button variant="danger" onClick={hideModal}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
